<template>
  <div class="flex items-start">
    <div
      class="profile-image-circle"
      style="height: 50px; width: 50px; margin-right: 10px; margin-top: 3px; text-align: center"
    >
      <img
        height="48px"
        width="48px"
        v-if="params.ProfilePictureURL"
        :src="params.ProfilePictureURL"
      />
      <span v-else>{{ getInitials(params.Name) }}</span>
    </div>
    <div class="" v-if="loggedInUserId == params.AttendeeId">

      <div style="line-height: 24px" >{{ params.Name }}</div>
      <div style="line-height: 18px" >{{ params.Email }}</div>
      <!-- <div style="line-height: 18px" >{{ params.Email }}</div> -->
      <!-- <div style="line-height: 18px" >{{ params.Email }}</div> -->
    </div>
    <div class="" v-else>
      <div style="line-height: 32px" >{{ params.Name }}</div>
      
    </div>
  </div>
</template>

<script>
import ls from "@/common/localStorage";
export default {
  name: "CellRendererName",
  data() {
    return {
      loggedInUserId: JSON.parse(
        ls.getSessionValueByKey("UserId")
      )
    }
  },
  methods: {
    getInitials: function (str) {
      var result = "";
      if (str) {
        str = str.trim();
        if (str) {
          var matches = str.match(/\b(\w)/g);
          if (matches) {
            result = matches.join("");
            if (result.length > 2) {
              result = result.substring(0, 2);
            }
          } else {
            result = str.substring(0, 2);
          }
        }
      }
      return result.toUpperCase();
    },
  },
  computed: {},
};
</script>
<style scoped>
.profile-image-circle img,
.profile-image-circle span {
  line-height: 40px;
  text-align: center;
  font-size: 1.4em;
  font-weight: bold;
  display: inline-block;
  height: 40px;
  width: 40px;
  /* border: 1px solid #000; */
  border-radius: 50%;
  background: #dbdbdb;
}
</style>